import _ from 'lodash';
import { FileBlockOptions } from 'pages/documents_v2/views/edit_area/blocks/block_types/FileBlockOptions';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';
import { useContext } from 'react';

import HelperFunctions from '../../../../../global/HelperFunctions';
import MediaSelector, { getFileUri, isValidUri } from '../../../../../media_library/views/MediaSelector';

const FILE_OPTIONS_DEFAULT_ALIGN = 'left';

export function FileBlock({ block, baseBlock, index, readOnly = false }) {
    const blockContent = block?.latestContent || block?.baseContent || '';
    const file = HelperFunctions.tryParseJSON(blockContent, null);

    const newFile =
        baseBlock && Object.hasOwn(baseBlock, 'baseContent')
            ? HelperFunctions.tryParseJSON(baseBlock.baseContent, null)
            : null;
    const localChanges = baseBlock?.changes ?? [];

    return (
        <div className="p-4">
            <div className="row">
                <div className="col-6">
                    {localChanges.length > 0 && <div className="font-weight-bold mb-2">Huidige versie:</div>}
                    <FileMedia file={file} readOnly={readOnly} index={index} />
                </div>
                <div className="col-6">
                    {localChanges.length > 0 && newFile && (
                        <>
                            <div className="font-weight-bold mb-2">Vorige versie:</div>
                            <div className="opacity-75">
                                <FileMedia file={newFile} readOnly={true} index={index} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

function FileMedia({ file, readOnly, index }) {
    const fileUri = getFileUri(_.get(file, 'uri', ''));
    const { updateBlock } = useContext(EditAreaContext);
    const hasMedia = isValidUri(fileUri);

    return (
        <div className="d-flex">
            <MediaSelector
                selectedValue={fileUri}
                readOnly={readOnly}
                onChange={(file) => {
                    const description = _.get(file, 'description', null);

                    const latestContent = JSON.stringify({
                        uri: _.get(file, '@id', ''),
                        options: {
                            align: FILE_OPTIONS_DEFAULT_ALIGN,
                            description: description ?? '',
                            alt: '',
                            url: '',
                            customSize: false,
                            width: '',
                            height: '',
                        },
                    });

                    updateBlock(latestContent, index);
                }}
            />

            {hasMedia && <FileBlockOptions file={file} />}
        </div>
    );
}
